module.exports = __webpack_public_path__ + "img/mobileapplication6.eb73acac.png";